import { AuthActionsTypes } from "../constants/AuthActionTypes";

// default state.
const AuthState = {
    isLoggedIn: null,
    studentData: null
}


// switch statement to handle various types of actions
export const AuthReducer = (state = AuthState, { type, payload }) => {
    switch (type) {
        case AuthActionsTypes.LOGIN_SUCCESS:
            var updatedState = {
                isLoggedIn: true,
                studentData: payload
            }
            return updatedState;
        case AuthActionsTypes.GET_USER_SUCCESS:
            var updatedState_GET_USER_SUCCESS = {
                isLoggedIn: true,
                studentData: payload
            }
            return updatedState_GET_USER_SUCCESS;
        case AuthActionsTypes.GET_USER_FAILS:
            var updatedState_GET_USER_FAILS = { ...state };
            updatedState_GET_USER_FAILS.isLoggedIn = false;
            return updatedState_GET_USER_FAILS;
        case AuthActionsTypes.LOGOUT:
            return {
                isLoggedIn: false,
                studentData: null
            }
        default:
            return state;
    }
}